import { household } from "propTypes/household.propType";
import { position } from "propTypes/position.propType";
import propTypes from "prop-types";

export default {
  streetName: propTypes.string,
  households: propTypes.arrayOf(household),
  position: position
};
